import { useState, type FormEvent } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../lib/firebase.js';

interface SearchResult {
  id: string;
  category?: string;
  docType?: string;
  originalName?: string;
  summary?: string;
  parties?: string[];
}

export function SearchBar({ onResults }: { onResults: (results: SearchResult[] | null) => void }) {
  const [q, setQ] = useState('');
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (q.trim().length < 2) {
      onResults(null);
      return;
    }
    setBusy(true);
    try {
      const search = httpsCallable<{ query: string; limit?: number }, { results: SearchResult[] }>(
        functions,
        'searchDocuments',
      );
      const res = await search({ query: q, limit: 20 });
      onResults(res.data.results);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="flex gap-2" onSubmit={onSubmit}>
      <input
        type="search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Semantic search — try 'Topco3 distribution', 'Q1 capital call'…"
        className="flex-1 rounded border border-stone-300 px-3 py-1.5 text-sm"
      />
      <button type="submit" className="btn-primary" disabled={busy}>
        {busy ? 'Searching…' : 'Search'}
      </button>
      {q && (
        <button
          type="button"
          className="btn-secondary"
          onClick={() => {
            setQ('');
            onResults(null);
          }}
        >
          Clear
        </button>
      )}
    </form>
  );
}
